import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { Route, Redirect, Link, useLocation } from "react-router-dom";
import {
  Row,
  Col,
  Table,
  Form,
  Input,
  Switch,
  Select,
  Checkbox,
  Button,
  Modal,
  Cascader,
  message,
  Slider,
  InputNumber,
  Tag,
  Upload,
} from "antd";
import cookie from "react-cookies";
import "./list.less";
import {
  ExclamationCircleOutlined,
  LoadingOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import moment from "moment";
import qs from "qs";
import {} from "../../api/user";

const List = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    console.log(pathname);
  }, []);

  return (
    <div className="task detail px-5">
      <div className="actions d-flex justify-content-between mb-3">
        <Button size="large" href="/index/task/list">Back List</Button>
        <Button size="large" type="primary">
          Download
        </Button>
      </div>
      <div className="preview">
        <img src={require('../../assets/image/membercard2.png').default} />
      </div>
    </div>
  );
};

export default List;
